import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer id="contact" className="w-full border-t border-white/10 bg-obsidian">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* Identity */}
          <div className="flex flex-col space-y-4">
            <div>
              <h3 className="text-white font-medium text-lg">Giancarlo Guacci</h3>
              <p className="text-sm font-mono text-zinc-400 mt-1">{t.footer.role}</p>
            </div>
            <div className="pt-2">
              <p className="text-sm font-mono text-zinc-400 mt-1">{t.footer.vat}</p>
            </div>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col space-y-4">
            <span className="text-xs font-mono text-emerald uppercase tracking-widest">{t.footer.channels}</span>
            <div className="flex flex-col space-y-2">
              <a href="mailto:giancarlo@gguacci.com" className="text-sm font-mono text-mutedGray hover:text-white transition-colors">
                giancarlo@gguacci.com
              </a>
              <a href="tel:+393471309218" className="text-sm font-mono text-mutedGray hover:text-white transition-colors">
                +39 347 130 9218
              </a>
            </div>
          </div>

          {/* Socials */}
          <div className="flex flex-col space-y-4">
            <span className="text-xs font-mono text-emerald uppercase tracking-widest">{t.footer.connect}</span>
            <div className="flex flex-col space-y-2">
              <a 
                href="https://www.linkedin.com/in/giancarlo-guacci" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-sm font-mono text-mutedGray hover:text-white transition-colors"
              >
                LinkedIn
              </a>
            </div>
          </div>

          {/* System Status */}
          <div className="flex flex-col justify-start items-start md:items-end">
            <div className="flex items-center gap-3 px-4 py-2 border border-white/5 bg-white/[0.02]">
              <div className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald"></span>
              </div>
              <span className="font-mono text-xs text-emerald tracking-widest">
                {t.footer.status}
              </span>
            </div>
          </div>

        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <span className="text-[10px] font-mono text-zinc-700">
            {t.footer.rights}
          </span>
          <span className="text-[10px] font-mono text-zinc-700">
            {t.footer.encrypted}
          </span>
        </div>
      </div>
    </footer>
  );
};